
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_w6u2l_23",
  "fit-height": "awsui_fit-height_14iqq_w6u2l_57",
  "with-side-media": "awsui_with-side-media_14iqq_w6u2l_62",
  "variant-default": "awsui_variant-default_14iqq_w6u2l_65",
  "variant-stacked": "awsui_variant-stacked_14iqq_w6u2l_65",
  "refresh": "awsui_refresh_14iqq_w6u2l_74",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_w6u2l_124",
  "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_w6u2l_130",
  "focus-ring": "awsui_focus-ring_14iqq_w6u2l_137",
  "with-top-media": "awsui_with-top-media_14iqq_w6u2l_161",
  "content-wrapper": "awsui_content-wrapper_14iqq_w6u2l_166",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_w6u2l_171",
  "media": "awsui_media_14iqq_w6u2l_178",
  "media-top": "awsui_media-top_14iqq_w6u2l_197",
  "media-side": "awsui_media-side_14iqq_w6u2l_202",
  "header": "awsui_header_14iqq_w6u2l_208",
  "header-full-page": "awsui_header-full-page_14iqq_w6u2l_213",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_w6u2l_216",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_w6u2l_216",
  "header-with-media": "awsui_header-with-media_14iqq_w6u2l_219",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_w6u2l_225",
  "header-stuck": "awsui_header-stuck_14iqq_w6u2l_235",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_w6u2l_248",
  "with-paddings": "awsui_with-paddings_14iqq_w6u2l_254",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_w6u2l_263",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_w6u2l_321",
  "header-cover": "awsui_header-cover_14iqq_w6u2l_324",
  "content": "awsui_content_14iqq_w6u2l_166",
  "content-fit-height": "awsui_content-fit-height_14iqq_w6u2l_352",
  "content-inner": "awsui_content-inner_14iqq_w6u2l_358",
  "with-header": "awsui_with-header_14iqq_w6u2l_365",
  "footer": "awsui_footer_14iqq_w6u2l_369",
  "with-divider": "awsui_with-divider_14iqq_w6u2l_381"
};
  